type IconProps = {
  className?: string;
};

export const TrashIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M10.14 2.42H4.65v-.01c0-.13.03-.25.09-.37C5.09 1.29 6.18.77 7.39.77c1.21 0 2.3.52 2.65 1.25.06.13.1.26.1.4Zm4.26 0h-3.5a2.1 2.1 0 0 0-.19-.73C10.24.68 8.9 0 7.39 0 5.88 0 4.54.68 4.07 1.69c-.11.24-.17.48-.18.73H.38c-.21 0-.38.18-.38.4 0 .22.17.4.38.4h1.17L2 15.14c.05.65.59 1.31 1.57 1.31h7.84c.98.02 1.53-.64 1.58-1.29l.5-11.94h.91c.21 0 .39-.18.39-.4 0-.22-.18-.4-.39-.4Zm-1.69.82-.48 11.86c-.02.22-.21.58-.81.58l-7.84-.01c-.6-.01-.79-.37-.8-.56L2.32 3.22l10.39.02ZM9.92 13.96H9.9a.37.37 0 0 1-.35-.39l.29-8.26c.01-.2.17-.36.37-.36h.01c.2.01.36.18.35.39l-.29 8.25c-.01.21-.17.37-.36.37Zm-5.05 0c-.2 0-.36-.16-.37-.37l-.29-8.25c-.01-.21.15-.39.35-.4.24-.01.37.16.38.37l.29 8.25c.01.21-.15.38-.35.39h-.01Zm2.65 0a.37.37 0 0 1-.37-.38V5.32c0-.21.16-.38.37-.38.2 0 .36.17.36.38v8.26c0 .21-.16.38-.36.38Z" />
  </svg>
);
